import type { TicketTemplate } from '../../types';
import type { ChangeWorkGroup } from '../../types/changes';
import {
  incidentCustomFieldDefaultsForWorkflow,
  type IncidentSendDraft,
  type IncidentWorkflowOption,
  workflowsForIncidentGroup,
} from './incidentQuickSend';

export type ApplyTicketTemplateResult = {
  patch: Partial<IncidentSendDraft>;
  /** Campos do template ignorados (incompatíveis com a área ou fluxo). */
  skipped: string[];
};

/**
 * Aplica template US10 ao rascunho de chamado externo da mudança.
 * Não altera APIs de template; espelha o applyTemplate do Dashboard com validação de área.
 */
export function applyTicketTemplateToIncidentDraft(
  template: TicketTemplate,
  group: ChangeWorkGroup,
  workflows: IncidentWorkflowOption[],
): ApplyTicketTemplateResult {
  const skipped: string[] = [];
  const patch: Partial<IncidentSendDraft> = {};
  const allowedFlows = workflowsForIncidentGroup(group, workflows);

  const title = (template.title || '').trim();
  const description = (template.description || '').trim();
  if (title) patch.title = title;
  if (description) patch.comments = description;

  if (template.urgency) {
    patch.urgency = template.urgency;
  }

  const templateWorkflowId = template.workflow_id ? Number(template.workflow_id) : 0;
  if (templateWorkflowId > 0) {
    const flow = allowedFlows.find((item) => item.id === templateWorkflowId);
    if (flow) {
      patch.workflow_id = templateWorkflowId;
      patch.customFieldValues = incidentCustomFieldDefaultsForWorkflow(group, templateWorkflowId);
      patch.customFieldFiles = {};
      const queueId = template.assigned_group_id ? Number(template.assigned_group_id) : 0;
      if (queueId > 0) {
        if (flow.group_ids.includes(queueId)) {
          patch.incidents_group_id = queueId;
        } else {
          skipped.push('fila do template');
          patch.incidents_group_id = undefined;
        }
      }
    } else {
      skipped.push('fluxo do template');
    }
  }

  return { patch, skipped };
}
